import { Formatter } from 'utils';
import type { ViagemControle } from './types';

export const isViagemEligibleForBilling = (viagem: ViagemControle) => {
  const billing = viagem.billingItem?.billing;

  if (!billing) {
    if (viagem.billingItem) return true;

    return Boolean(viagem.approvedAt) && !viagem.rejectedAt;
  }

  return Boolean(billing.rejectedAt || billing.reversedAt);
};

export const parseViagemCurrencyValue = (value?: number | string | null) => {
  if (value === null || value === undefined || value === '') return 0;

  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const normalizedValue = value
    .replace(/[^\d,.-]/g, '')
    .replace(/\.(?=\d{3}(?:\D|$))/g, '')
    .replace(',', '.');
  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

export const sumViagensEstadia = (
  viagens: Pick<ViagemControle, 'valorEstadia'>[]
) => {
  return viagens.reduce(
    (total, viagem) => total + parseViagemCurrencyValue(viagem.valorEstadia),
    0
  );
};

export const formatViagemCurrency = (
  value?: number | string | null,
  fallback = '---'
) => {
  if (value === null || value === undefined || value === '') return fallback;

  return Formatter.currency(parseViagemCurrencyValue(value));
};
